import JobsArchive from './JobsArchive'

export default JobsArchive
